"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppMenu = void 0;
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
var react_2 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var atoms_1 = require("../../atoms");
var styles_1 = require("./styles");
exports.AppMenu = react_2.default.memo(function (_a) {
    var options = _a.options, secondaryOptions = _a.secondaryOptions, logo = _a.logo, onItemClick = _a.onItemClick;
    var classes = (0, styles_1.useStyles)();
    return ((0, jsx_runtime_1.jsxs)("nav", __assign({ "data-testid": "app-menu", className: classes.root }, { children: [(0, jsx_runtime_1.jsx)(core_1.Box, __assign({ component: "div", "data-testid": "logo-container", p: 1.5, pb: 1, bgcolor: "primary.dark" }, { children: logo })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.topMenu }, { children: options.map(function (_a) {
                    var rest = __rest(_a, []);
                    return ((0, react_1.createElement)(atoms_1.NavMenuButton, __assign({}, rest, { "data-testid": "menu-item", key: rest.id, role: "link", isSelected: rest.selected, onClick: function (event) {
                            if (onItemClick)
                                onItemClick(event, __assign({}, rest));
                        } })));
                }) })), secondaryOptions && ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.bottomMenu }, { children: secondaryOptions.map(function (_a) {
                    var onClick = _a.onClick, rest = __rest(_a, ["onClick"]);
                    return ((0, react_1.createElement)(atoms_1.NavSubMenuButton, __assign({}, rest, { "data-testid": "menu-item", key: rest.id, role: "link", isSelected: rest.selected, onClick: function (event) {
                            if (onClick)
                                onClick(event, __assign({}, rest));
                        } })));
                }) })))] })));
});
